<style scoped>  

  @media only screen and (max-width: 360px) {
    .search-input {
      max-width: 80% !important;
    }
  }

  @media only screen and (min-width: 361px) {
    .search-input {
      max-width: 85% !important;
    }
  }

  .action-button {
    min-width: 130px;
  }

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="ten wide computer sixteen wide tablet sixteen wide mobile column">
        <router-link class="ui blue button action-button" to="/financial/customer-invoices/new">
          <i class="plus icon"></i> Novo Fechamento
        </router-link>
      </div>
      <div class="six wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="customer-invoices-search-input" ref="searchInput" class="search-input" @onSearch="search" />
              <button class="ui icon button m-l-10" @click="$refs.filterModal.show()">
                <i class="filter icon" :class="{ red: !!$store.state.pages.filters.customerInvoices }"></i>
              </button>
            </div>
          </div>                        
        </div> 
      </div>      
    </div>

    <data-table id="customer-invoices-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="id" :asc="false" @onRowClick="onShowInvoice" />

    <filter-modal ref="filterModal" @onApply="filter" @onRemove="clearFilter" />

  </div>

</template>

<script>
  
  import moment from "moment"
  import FilterModal from "./filter"  
  import CustomerInvoiceService from "@/services/customer-invoice-service"
  import { gridPage, onlyFinancial } from "@/mixins"

  export default {    

    name: "CustomerInvoicesPage",

    mixins: [gridPage, onlyFinancial],

    data() {
      return {       
        title: "Fechamentos de Clientes", 
        service: new CustomerInvoiceService(),
        attributes: ["id", "status", "date", "startDate", "endDate", "value"],
        fields: [          
          { prop: "id", label: "Número" },
          { prop: "status", label: "Status", render: this.renderStatus },
          { prop: "customer.shortName", model: "Customer", label: "Cliente" },
          { prop: "date", label: "Data Criação", render: (invoice) => this.$formatDate(invoice.date) },
          { prop: "startDate", label: "Data Inicial", render: (invoice) => this.$formatDate(invoice.startDate) },
          { prop: "endDate", label: "Data Final", render: (invoice) => this.$formatDate(invoice.endDate) },          
          { prop: "value", label: "Valor", render: (invoice) => "R$ " + this.$formatCurrency(invoice.value) },    
        ],
      }
    },

    components: {
      FilterModal,
    },

    methods: {

      renderStatus(invoice) {
        return CustomerInvoiceService.STATUS[invoice.status].label
      },

      onShowInvoice(data) {
        this.$router.push(`/financial/customer-invoices/${data.row.id}/show`)
      },
    },
  }

</script>